export { default } from './AutomaticFeeChangeTag';
